import {BaseClass, Thumbnail} from '@teemill/common/classes';

export default class BlogTag extends BaseClass {
  constructor({
    id = null,
    url = null,
    code = null,
    name = null,
    image = null,
    postCount = 0,
  } = {}) {
    super();

    this.id = id;
    this.url = url;
    this.code = code;
    this.name = name;
    this.postCount = postCount;

    this.image = new Thumbnail(image);
  }
}
